module.exports = __webpack_public_path__ + "static/HB2-scaled-68f93988eed5389bbc6fde354419be75.jpeg";